import { isArrivalTimeFeatureApplicable } from "./isArrivalTimeFeatureApplicable";
import { useArrivalTimeConfig } from "./useArrivalTimeConfig";
import { useArrivalTimeWorkplaceExclusionConfig } from "./useArrivalTimeWorkplaceExclusionConfig";

interface UseIsArrivalTimeEligibleProps {
  shiftStartIso?: string;
  isInstantBook?: boolean;
  workplaceType?: string;
  workplaceId: string;
  workplaceMsa: string;
}

/**
 * Checks if the shift is eligible for arrival time based on the shift start time and the arrival time config and if instant book is enabled.
 * It checks if the arrival time feature is enabled as well
 */
export function useIsArrivalTimeEligible(props: UseIsArrivalTimeEligibleProps) {
  const { shiftStartIso, isInstantBook, workplaceType, workplaceId, workplaceMsa } = props;
  const { shortLeadTimeOffsetInHours, useExpectedArrivalTime } = useArrivalTimeConfig();
  const { workplaceExclusions } = useArrivalTimeWorkplaceExclusionConfig();

  return isArrivalTimeFeatureApplicable({
    shiftStartIso,
    isInstantBook,
    shortLeadTimeOffsetInHours,
    useExpectedArrivalTime,
    workplaceType,
    workplaceId,
    workplaceMsa,
    workplaceExclusions,
  });
}
